
import React from 'react';
import { useNavigate } from 'react-router-dom';

const ProductsSection = () => {
  const navigate = useNavigate();

  const handleViewAllProducts = () => {
    navigate('/products');
  };

  const product = {
    id: 1,
    name: 'Extincteurs Professionnels',
    category: 'Sécurité Incendie',
    price: 'Sur devis',
    image: 'https://static.readdy.ai/image/686bee9df6fcbede85637f4fe190f1d8/3612a4668e14f804b2c143b17d046dbc.png',
    description: 'Gamme complète d\'extincteurs professionnels pour tous types de feux. Solutions certifiées conformes aux normes européennes EN3.',
    features: [
      'Poudre ABC polyvalente',
      'CO2 pour équipements électriques',
      'Mousse AFFF pour liquides',
      'Eau pulvérisée additivée',
      'Agents spéciaux (K, F)',
      'Certifications EN3'
    ],
    badge: 'Gamme Complète',
    brand: 'Multi-marques'
  };

  return (
    <div className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Notre Gamme <span className="text-red-600">Extincteurs</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Tous types d'extincteurs professionnels pour une protection incendie optimale
          </p>
        </div>

        {/* Featured Product */}
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
            {/* Product Image */}
            <div className="relative bg-gradient-to-br from-gray-100 to-gray-200 p-12 flex items-center justify-center">
              <div className="relative">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full max-w-md h-auto object-contain"
                />
                {product.badge && (
                  <div className="absolute -top-4 -right-4 bg-red-600 text-white px-4 py-2 rounded-full text-sm font-bold shadow-lg">
                    {product.badge}
                  </div>
                )}
                <div className="absolute -bottom-4 -left-4 bg-blue-600 text-white px-4 py-2 rounded-full text-sm font-bold shadow-lg">
                  {product.brand}
                </div>
              </div>
            </div>

            {/* Product Details */}
            <div className="p-12 flex flex-col justify-center">
              <div className="mb-4">
                <span className="text-red-600 font-semibold text-sm uppercase tracking-wide">
                  {product.category}
                </span>
              </div>
              
              <h3 className="text-3xl font-bold text-gray-900 mb-6">
                {product.name}
              </h3>
              
              <p className="text-gray-600 text-lg mb-8 leading-relaxed">
                {product.description}
              </p>

              {/* Features Grid */}
              <div className="grid grid-cols-2 gap-4 mb-8">
                {product.features.map((feature, index) => (
                  <div key={index} className="flex items-center">
                    <div className="w-2 h-2 bg-red-600 rounded-full mr-3"></div>
                    <span className="text-gray-700 text-sm font-medium">{feature}</span>
                  </div>
                ))}
              </div>

              {/* Price and Actions */}
              <div className="flex items-center justify-between mb-8">
                <div className="text-3xl font-bold text-red-600">{product.price}</div>
              </div>

            </div>
          </div>
        </div>

        {/* Technical Highlights */}
        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="text-center p-8 bg-white rounded-xl shadow-lg">
            <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-fire-line text-2xl text-red-600"></i>
            </div>
            <h4 className="text-xl font-bold text-gray-900 mb-2">Tous Types de Feux</h4>
            <p className="text-gray-600">Classes A, B, C, D, F - Solutions adaptées à chaque risque incendie</p>
          </div>
          
          <div className="text-center p-8 bg-white rounded-xl shadow-lg">
            <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-shield-check-line text-2xl text-blue-600"></i>
            </div>
            <h4 className="text-xl font-bold text-gray-900 mb-2">Certifiés EN3</h4>
            <p className="text-gray-600">Conformité européenne garantie pour tous nos extincteurs professionnels</p>
          </div>
          
          <div className="text-center p-8 bg-white rounded-xl shadow-lg">
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-tools-line text-2xl text-green-600"></i>
            </div>
            <h4 className="text-xl font-bold text-gray-900 mb-2">Installation & Maintenance</h4>
            <p className="text-gray-600">Service complet d'installation et maintenance préventive inclus</p>
          </div>
        </div>

        {/* CTA Section */}
        <div className="text-center mt-12">
          <button 
            onClick={handleViewAllProducts}
            className="whitespace-nowrap cursor-pointer bg-red-600 text-white px-8 py-4 rounded-lg font-semibold hover:bg-red-700 transition-all duration-200 text-lg"
          >
            Voir tous nos produits
            <i className="ri-arrow-right-line ml-2"></i>
          </button>
        </div>

        {/* Section Contrats de Maintenance */}
        <div className="mt-24 bg-gradient-to-br from-red-50 to-orange-50 rounded-3xl p-12 shadow-xl">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="mb-6">
                <span className="text-red-600 font-semibold text-sm uppercase tracking-wide">Maintenance Professionnelle</span>
              </div>
              <h3 className="text-4xl font-bold text-gray-900 mb-6">
                Contrats de <span className="text-red-600">Maintenance</span>
              </h3>
              <p className="text-xl text-gray-600 mb-8 leading-relaxed">
                Protégez vos investissements avec nos contrats de maintenance préventive spécialisés en détection incendie et extinction automatique.
              </p>

              <div className="space-y-6 mb-8">
                <div className="flex items-start">
                  <div className="w-12 h-12 bg-red-600 rounded-xl flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-fire-line text-white text-xl"></i>
                  </div>
                  <div>
                    <h4 className="text-xl font-bold text-gray-900 mb-2">Détection Incendie</h4>
                    <p className="text-gray-600">Contrôles périodiques des détecteurs, tests de sensibilité, nettoyage des capteurs et vérification des circuits de signalisation pour une fiabilité maximale.</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-12 h-12 bg-blue-600 rounded-xl flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-drop-line text-white text-xl"></i>
                  </div>
                  <div>
                    <h4 className="text-xl font-bold text-gray-900 mb-2">Extinction Automatique</h4>
                    <p className="text-gray-600">Maintenance des systèmes gazeux, contrôle des pressions, tests de déclenchement et rechargement des agents extincteurs selon normes EN.</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-12 h-12 bg-green-600 rounded-xl flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-shield-check-line text-white text-xl"></i>
                  </div>
                  <div>
                    <h4 className="text-xl font-bold text-gray-900 mb-2">Maintenance Préventive</h4>
                    <p className="text-gray-600">Anticipation des pannes, réduction des coûts d'intervention d'urgence, prolongation de la durée de vie des équipements et conformité réglementaire garantie.</p>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-2xl p-6 shadow-lg border border-gray-100 mb-8">
                <h5 className="text-lg font-bold text-gray-900 mb-4 flex items-center">
                  <i className="ri-calendar-check-line text-red-600 mr-2"></i>
                  Avantages de la Maintenance Préventive
                </h5>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="flex items-center">
                    <div className="w-2 h-2 bg-red-600 rounded-full mr-3"></div>
                    <span className="text-gray-700 text-sm">Réduction des pannes de 85%</span>
                  </div>
                  <div className="flex items-center">
                    <div className="w-2 h-2 bg-red-600 rounded-full mr-3"></div>
                    <span className="text-gray-700 text-sm">Économies jusqu'à 40%</span>
                  </div>
                  <div className="flex items-center">
                    <div className="w-2 h-2 bg-red-600 rounded-full mr-3"></div>
                    <span className="text-gray-700 text-sm">Conformité réglementaire</span>
                  </div>
                  <div className="flex items-center">
                    <div className="w-2 h-2 bg-red-600 rounded-full mr-3"></div>
                    <span className="text-gray-700 text-sm">Intervention 24h/24</span>
                  </div>
                  <div className="flex items-center">
                    <div className="w-2 h-2 bg-red-600 rounded-full mr-3"></div>
                    <span className="text-gray-700 text-sm">Durée de vie prolongée</span>
                  </div>
                  <div className="flex items-center">
                    <div className="w-2 h-2 bg-red-600 rounded-full mr-3"></div>
                    <span className="text-gray-700 text-sm">Rapports détaillés</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="relative">
              <div className="relative overflow-hidden rounded-2xl shadow-2xl">
                <img
                  src="https://public.readdy.ai/ai/img_res/51de8ea1d0b9f276eab55286ebb302a6.jpg"
                  alt="Maintenance Préventive"
                  className="w-full h-96 object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
                <div className="absolute top-6 right-6">
                  <div className="bg-red-600 text-white px-4 py-2 rounded-full text-sm font-bold shadow-lg">
                    Service 24/7
                  </div>
                </div>
                <div className="absolute bottom-6 left-6">
                  <div className="bg-white/90 backdrop-blur-sm rounded-xl p-4 shadow-lg">
                    <div className="flex items-center space-x-4">
                      <div className="w-12 h-12 bg-green-500 rounded-full flex items-center justify-center">
                        <i className="ri-check-line text-white text-xl"></i>
                      </div>
                      <div>
                        <div className="text-sm font-bold text-gray-900">Certification EN54</div>
                        <div className="text-xs text-gray-600">Conformité garantie</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Stats de maintenance */}
              <div className="absolute -bottom-8 -left-8 bg-white rounded-2xl p-6 shadow-xl border border-gray-100">
                <div className="text-center">
                  <div className="text-3xl font-bold text-red-600 mb-1">15+</div>
                  <div className="text-sm text-gray-600">Années d'expérience</div>
                </div>
              </div>

              <div className="absolute -top-8 -right-8 bg-white rounded-2xl p-6 shadow-xl border border-gray-100">
                <div className="text-center">
                  <div className="text-3xl font-bold text-blue-600 mb-1">500+</div>
                  <div className="text-sm text-gray-600">Contrats actifs</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductsSection;
